import React from 'react';

import { Input } from 'antd';

import { IBVControl } from '../../../models/BVControls/IBVControl';

import './bv-text-area.scss';

import BVControl from '../BVControl/bv-control';

const { TextArea } = Input;

interface IBVInput extends IBVControl {
    properties: any;
}

const BVInput: React.FunctionComponent<IBVInput> = ({ className, errorMessage, infoMessage, label, properties, required }) => (
    <BVControl className={`bv-text-area ${className}`} errorMessage={errorMessage} infoMessage={infoMessage} label={label} required={required}>
        <TextArea rows={4} {...properties} />
    </BVControl>
);

export default BVInput;